export const mainUrl = "https://commitedcargo.alobhatech.com/";
// local

// export const adminMainUrl = "http://localhost:5800";

// dev
// export const adminMainUrl_old = "https://ccargoapi.alobhatech.com";
// export const adminMainUrl = "https://nedlloydhrms.flexichains.com";
export const adminMainUrl = "https://ccargoapi.alobhadev.com";  //this one
// for the dev-master
// export const adminMainUrl = "https://devmaster-committedapi.alobhadev.com";  //this one
// this is dev-master push example test
// export const adminMainUrl = "https://api.flexichains.com";
// export const adminMainUrl = "http://localhost:5890";



//staging url
// export const adminMainUrl = "https://cargodev.alobhatech.com";

//live
// export const adminMainUrl = "https://flexichains.com"


//live for committed cargo
// export const adminMainUrl = "https://committedbackend.flexichains.com"


// export const HRMSGOURL = "http://alobhatech.com/hrmsgo";


// staging
// export const adminMainUrl = "https://cargostagging.alobhatech.com";
